import AsyncComponent from "../../component/asynccomponent/AsyncComponent";
import { RolesEnum, CompanyTypesEnum } from "../../utils/Enums";

const budgetForm = AsyncComponent(() =>
  import("../../../pages/budget/BudgetForm")
);

const budgetGrid = AsyncComponent(() =>
  import("../../../pages/budget/BudgetGrid")
);

const proposals = AsyncComponent(() =>
  import("../../../pages/budget/proposal/index.proposal")
);

export default [
  {
    path: "/budget",
    component: budgetForm,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: "/budget/:id",
    component: budgetForm,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: "/budget/:id/proposals",
    component: proposals,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: "/budgets",
    component: budgetGrid,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  }
];



// WEBPACK FOOTER //
// ./src/shared/infra/routes/BudgetRoutes.js